import '../styling/ComingSoon.css';

const ComingSoon = () => {
    return (
        <section className="comingsoon">
            <div className="comingsoon_content">
                <h5>Stay Tuned</h5>
                <h1>Coming Soon</h1>
                <p>We’re working hard to bring something amazing. Check back soon!</p>
                <button
                    className="notify_button"
                    onClick={() => window.location.href = '/'}
                >
                    Back to Home
                </button>
            </div>
        </section>
    );
};

export default ComingSoon;
